<template>
  <MatrizRfmFaixasTable
    dimensao="recencia"
    titulo="Recência (R)"
    descricao="Considera a quantidade de dias desde a última compra do cliente. Quanto mais recente a compra, maior a pontuação."
    cardId="card-configuracao-recencia"
    rotuloDe="De (dias)"
    rotuloAte="Até (dias)"
    placeholder="Ex.: 30"
    :faixas="faixas"
    :erros="erros"
    :classificacoes="classificacoes"
    :formatador="formatarDias"
    :regraFormatador="regra"
    @alterar="payload => $emit('alterar', payload)"
    @restaurar="$emit('restaurar')"
  />
</template>

<script>
import MatrizRfmFaixasTable from "./MatrizRfmFaixasTable";

export default {
  name: "MatrizRfmRecencia",
  components: { MatrizRfmFaixasTable },
  props: {
    faixas: { type: Array, required: true },
    erros: { type: Array, default: () => [] }
  },
  data: () => ({
    classificacoes: {
      5: "Excelente (compra mais recente)",
      4: "Muito bom",
      3: "Médio",
      2: "Em risco",
      1: "Inativo (mais tempo sem comprar)"
    }
  }),
  methods: {
    formatarDias(valor) {
      return `${valor} dias`;
    },
    regra(faixa) {
      if (faixa.semLimite) {
        return faixa.de === null ? "-" : `Acima de ${faixa.de - 1} dias`;
      }
      if (faixa.de === null || faixa.ate === null) return "-";
      return `${faixa.de} até ${faixa.ate} dias`;
    }
  }
};
</script>
